import React, { useEffect, useRef, useState, useContext } from 'react';
import { TweenMax } from "gsap";

// Components
import StreamVideoPopup from '../components/Popup/StreamVideoPopup';
import Person from '../components/Person/Person';
import ArtistList from '../components/Artist/ArtistList';
import { ApiContext } from '../context/api/apiContext';
import { sortByQuery } from '../utils/index';
import { useTogglePopup } from '../utils/useTogglePopup';

// Assets
import HeroBg from '../i/hero_bg.jpg';
import BgSection1 from '../i/bg_section_1.jpg';

import PlayIcon from '../i/icons/play.svg';
import AppleIcon from '../i/icons/apple.svg';
import GooglePlayIcon from '../i/icons/google_play.svg';

const Home = () => {
	const heroPhoneImg = useRef(null);
	const heroPhoneImgSecond = useRef(null);
	const [isPopupOpen, showPopup, hidePopup] = useTogglePopup();
	const [filteredChannels, setFilteredChannels] = useState([]);
	const [activeChannel, setActiveChannel] = useState(0);
	const { channels, getAllChannels, jsonData } = useContext(ApiContext);
	const { supportedSystems } = jsonData.defaultSectionSettings;
	const {
		heroSection,
		connectSection,
		howStreamInWorks,
		personSection,
		category,
	} = jsonData.pages.home;

	const setAllChannels = async () => {
		const resChannels = await getAllChannels();

		setFilteredChannels(resChannels);
	};

	const sortChannels = (type, activeChannel) => {
		const typeChannel = type.toLowerCase();
		setActiveChannel(activeChannel);

		if (typeChannel === 'all') {
			setFilteredChannels(channels);
		} else {
			const newArray = sortByQuery(channels, type);
			setFilteredChannels(newArray);
		}

	};

	useEffect(() => {
		let tl = new TimelineMax({});

		tl
			.to(heroPhoneImg.current, 3, {
				yPercent: -50,
				duration: 3,
				delay: 1
			})
			.set(heroPhoneImg.current, { opacity: 0 })
			.set(heroPhoneImgSecond.current, { opacity: 1 }, "-=.2")

		setAllChannels();
	}, []);

	return (
		<React.Fragment>
			<section className="section hero_mod bottom_decor_mod">
				<div className="section_bg loaded_mod" style={{ backgroundImage: `url(${HeroBg})` }} />
				<div className="section_in hero_mod">
					<div className="section_heading center_level_mod hero_mod">
						<h1 className="section_title offset_mod hero_mod">{heroSection.title}</h1>
						<div className="section_descr hero_mod darken_mod">
							<p>{heroSection.description}</p>
						</div>
						<a className="btn_download offset_mod" href={heroSection.buttonUrl}>{heroSection.buttonTitle}</a>
						<ul className="system_list">
							{supportedSystems.map(({ title }, index) => {
								const preparedTitle = title.toLowerCase();
								let Icon;

								if (preparedTitle === 'ios') {
									Icon = <AppleIcon className="icon icon-apple white_mod size_mod" />
								} else {
									Icon = <GooglePlayIcon className="icon icon-apple white_mod size_mod" />;
								}

								return (
									<li className="system_list_item" key={index}>
										<div className="system_list_item_w_icon">
											{Icon}
										</div>
										<span className="system_list_name">{title}</span>
									</li>
								)
							})}
						</ul>
					</div>
					<div className="hero_phone">
						<img className="hero_phone_img" src={heroSection.heroPhoneImg} alt="Phone" />
						<div className="hero_phone_in">
							<img
								ref={heroPhoneImg}
								className="hero_phone_in_img v1_mod"
								src={heroSection.heroImgOne}
								alt="hero phone screen"
							/>
							<img
								ref={heroPhoneImgSecond}
								className="hero_phone_in_img v2_mod"
								src={heroSection.heroImgSecond}
								alt="hero phone screen"
							/>
						</div>
					</div>
				</div>
			</section>
			<section className="section">
				<div className="section_in">
					<div className="tab_links">
						{category.map((item, index) => {
							return (
								<button
									className={`tab_link artist_mod ${activeChannel == index ? 'active_state' : ''}`}
									key={item + index}
									onClick={() => sortChannels(item, index)}
								>
									{item}
								</button>
							)
						})}
					</div>
					<div className="tabs_content_wrap">
						<div className="tab_content artist_mod active_tab">
							<ArtistList
								channels={filteredChannels}
							/>
						</div>
					</div>
				</div>
			</section>
			<section className="section info_mod center_level_mod double_decor_mod">
				<div className="section_bg loaded_mod" style={{ backgroundImage: `url(${BgSection1})` }} />
				<div className="section_in limit_mod">
					<div className="section_block right_level_mod">
						<h2 className="section_title offset_mod">{connectSection.title}</h2>
						<div className="section_descr offset_mod darken_mod">{connectSection.description}</div>
						<a className="btn_base" href={connectSection.buttonUrl}>{connectSection.buttonTitle}</a>
					</div>
				</div>
			</section>
			<section className="section">
				<div className="section_in limit_mod">
					<div className="stream_works_row">
						<div className="stream_works_info">
							<h2 className="section_title offset_mod accent_mod">{howStreamInWorks.title}</h2>
							<div className="section_descr offset_v1_mod accent_mod">
								{howStreamInWorks.description.map((text, index) => {
									return (
										<p key={index}>{text}</p>
									)
								})}
							</div>
							<div
								className="stream_works_video btnOpenStreamVideo"
								onClick={showPopup}
							>
								<img className="stream_works_video_in" src={howStreamInWorks.previewVideoImg} alt="Video" />
								<div className="btn_play position_mod">
									<div className="btn_play_icon">
										<PlayIcon className="icon icon-play play_mod white_mod size_mod" />
									</div>
								</div>
							</div>
						</div>
						<div className="stream_works_w_img">
							<img className="stream_works_img" src={howStreamInWorks.contentImg} alt={howStreamInWorks.contentAlt} />
						</div>
					</div>
				</div>
				<div className="section_in">
					<ul className="person_list">
						{personSection.list.map(({ name, position, description }, index) => {
							return (
								<li className="person_list_item" key={index}>
									<Person
										name={name}
										position={position}
										descr={description}
									/>
								</li>
							)
						})}
					</ul>
				</div>
			</section>
			{
				isPopupOpen ?
					<StreamVideoPopup hidePopup={hidePopup} /> : false
			}
		</React.Fragment>
	)
};

export default Home;